import { render } from "./ui-task-form-add.vue?vue&type=template&id=74488c18&scoped=true"
import script from "./ui-task-form-add.vue?vue&type=script&lang=js"
export * from "./ui-task-form-add.vue?vue&type=script&lang=js"

import "./ui-task-form-add.vue?vue&type=style&index=0&id=74488c18&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74488c18"]])

export default __exports__